document.addEventListener('DOMContentLoaded', ()=>{
    const header = document.getElementById('header');
    const burgerButton = document.getElementById('hamburgerMenuButton');

    const mobileNavWrapper = document.getElementById('mobileNavWrapper');

    const body = document.body;

    function setMobileNavPosition(){
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }


    burgerButton.addEventListener('click', ()=>{

        let isMenuOpen = body.classList.contains('menu-open');

        if (isMenuOpen) {
            body.classList.remove('menu-open');


            setTimeout(()=>{
                mobileNavWrapper.style.display = 'none';
            },300)

            burgerButton.setAttribute('aria-expanded', 'false');
            mobileNavWrapper.setAttribute('aria-hidden', 'true');
        }else{

            mobileNavWrapper.style.display = 'block';

            setTimeout(()=>{
                body.classList.add('menu-open');
            },10)

            burgerButton.setAttribute('aria-expanded', 'true');
            mobileNavWrapper.setAttribute('aria-hidden', 'false');
        }

        setMobileNavPosition()
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.mobile-menu-wrapper') && body.classList.contains('menu-open')) {
            body.classList.remove('menu-open');


            setTimeout(()=>{
                mobileNavWrapper.style.display = 'none';
            },300)

            burgerButton.setAttribute('aria-expanded', 'false');
            mobileNavWrapper.setAttribute('aria-hidden', 'true');
        }
    })

    window.addEventListener('resize', setMobileNavPosition);
    setMobileNavPosition();



    /*
    Menu Dropdown and Megamenu logic
     */

    const triggers = document.querySelectorAll('.megamenu-trigger, .dropdown-trigger');
    console.log(triggers);

    if (triggers.length > 0){

        triggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                const isOpen = trigger.classList.contains('is-open');

                const subMenu = trigger.nextElementSibling;
                // const subMenu2 = trigger.parentNode.querySelector('.sub-menu');

                // Close all OTHER menus first
                closeOtherSubMenus(trigger);

                if (isOpen) {
                    closeMenu(trigger, subMenu);
                } else {
                    openMenu(trigger, subMenu);
                }

            })
        })


        // Close menus when clicking outside
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.menu-item')) {
                closeAllSubMenus();
            }
        });
    }



    function openMenu(trigger, subMenu) {
        trigger.classList.add('is-open');
        subMenu.style.display = 'block';

        setTimeout(() => {
            subMenu.classList.add('is-open');
        }, 10);

        trigger.setAttribute('aria-expanded', 'true');
        subMenu.setAttribute('aria-hidden', 'false');
    }

    function closeMenu(trigger, subMenu) {
        trigger.classList.remove('is-open');
        subMenu.classList.remove('is-open');

        setTimeout(() => {
            subMenu.style.display = 'none';
        }, 300); // <-- Match CSS transition time

        trigger.setAttribute('aria-expanded', 'false');
        subMenu.setAttribute('aria-hidden', 'true');
    }

    function closeOtherSubMenus(currentTrigger) {
        triggers.forEach((trigger) => {
            if (trigger !== currentTrigger && trigger.classList.contains('is-open')) {
                const subMenu = trigger.nextElementSibling;
                closeMenu(trigger, subMenu);
            }
        });
    }

    function closeAllSubMenus() {
        triggers.forEach((trigger) => {
            if (trigger.classList.contains('is-open')) {
                const subMenu = trigger.nextElementSibling;
                closeMenu(trigger, subMenu);
            }
        });
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllSubMenus();
        }
    });


    /*
     * MOBILE MENU
     */

    const mobileDropdownTriggers = document.querySelectorAll('.mobile-dropdown-trigger');

    if (mobileDropdownTriggers.length > 0){
        mobileDropdownTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const isOpen = trigger.classList.contains('is-open');

                const subMenu = trigger.nextElementSibling;

                if (isOpen) {
                    trigger.classList.remove('is-open');
                    subMenu.classList.remove('is-open');
                    subMenu.style.maxHeight = '0';
                    trigger.setAttribute('aria-expanded', 'false');
                    subMenu.setAttribute('aria-hidden', 'true');
                } else {
                    trigger.classList.add('is-open');
                    subMenu.classList.add('is-open');
                    subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
                    trigger.setAttribute('aria-expanded', 'true');
                    subMenu.setAttribute('aria-hidden', 'false');
                }
            })
        })
    }

})